// extracted by mini-css-extract-plugin
export var button = "_mf-0";
export var donut = "_mf-1";
export var donutFill = "_mf-3";
export var donutTrack = "_mf-2";